import { render, staticRenderFns } from "./purchaseReturnNoticesTask.vue?vue&type=template&id=75bfe816&scoped=true"
import script from "./purchaseReturnNoticesTask.vue?vue&type=script&lang=js"
export * from "./purchaseReturnNoticesTask.vue?vue&type=script&lang=js"
import style0 from "./purchaseReturnNoticesTask.vue?vue&type=style&index=0&id=75bfe816&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bfe816",
  null
  
)

export default component.exports